import React from 'react'
import { SpacerSpacing } from './SpacerSpacing.type'

export type SpacerProps = {
  spacing?: SpacerSpacing
  children?: React.ReactNode
  testId?: string
}

export const Spacer = (props: SpacerProps) => {
  const { spacing, children, testId } = props

  const classList: string[] = []

  switch (spacing) {
    case 'bottom':
      classList.push('u-sm-marginBottom32')
      classList.push('u-marginBottom48')
      break
    case 'top':
      classList.push('u-sm-marginTop32')
      classList.push('u-marginTop48')
      break
    case 'full':
      classList.push('u-sm-marginVert32')
      classList.push('u-marginVert48')
      break
    case 'nospace':
      break
  }

  if (classList.length === 0) {
    return children
  }

  return (
    <div
      className={classList.join(' ')}
      data-testid={testId ? `${testId}-wrapper` : null}
    >
      {children}
    </div>
  )
}
